module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pii"
    }
  }, [_vm._v("It is of no use to criticize humanity. Like all creations, it survives its critics. The only interesting thing is to try to understand it or, at least, appreciate. Perhaps Coney Island is the most human thing that God ever made, or permitted the Devil to make.")])]), _c('a', {
    attrs: {
      "id": "pii"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("—Richard LeGallienne,")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_vm._v("1905")])])]), _c('a', {
    attrs: {
      "id": "pii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2885afbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Fm3.vue
// module id = 75
// module chunks = 0